import React from 'react';
import { DrawingConverter } from '../components/features/drawing-conversion/DrawingConverter';

/**
 * 図面変換ページコンポーネント
 * 図面変換機能のメインページを提供する
 */
export const DrawingConversionPage: React.FC = () => {
  // region: レンダリング処理
  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">図面変換</h1>
      <DrawingConverter />
    </div>
  );
  // endregion
};

export default DrawingConversionPage;